import emailjs from "@emailjs/browser";

const EMAILJS_SERVICE_ID = "service_jpezr0s";
const EMAILJS_PUBLIC_KEY = "Qc73pj33bbA0EKVxQ";
const BOOK_TEMPLATE_ID = "template_h6tfu65";

function requireRecipient(recipient) {
	if (!recipient) {
		throw new Error("The customer's email address is missing.");
	}
}

export function sendBookPurchaseConfirmation(order, orderId) {
	requireRecipient(order.buyerEmail);
	return emailjs.send(EMAILJS_SERVICE_ID, BOOK_TEMPLATE_ID, {
		to_name: order.buyerName || "Customer",
		to_email: order.buyerEmail,
		email_subject: "Purchase confirmed",
		email_title: "Purchase Confirmed",
		email_intro: "Your book purchase has been received. Here are the order details:",
		report_body: "",
		action_label: "Visit the bookstore",
		action_url: "https://jabuzwane.co.za/books",
		service_name: `Book purchase: ${order.bookTitle || "Book"}`,
		booking_date: `Order reference: ${order.orderId || orderId}`,
		booking_time: order.format === "hardCopy" ? "Hard copy" : "Online PDF",
		duration: new Intl.NumberFormat("en-ZA", {
			style: "currency",
			currency: order.currency || "ZAR",
		}).format(Number(order.price) || 0),
	}, EMAILJS_PUBLIC_KEY);
}

export function sendBookDeliveryUpdate(order, deliveryStatus) {
	requireRecipient(order.buyerEmail);
	return emailjs.send(EMAILJS_SERVICE_ID, BOOK_TEMPLATE_ID, {
		to_name: order.buyerName || "Customer",
		to_email: order.buyerEmail,
		email_subject: "Book delivery update",
		email_title: "Delivery Update",
		email_intro: "There is an update about your book order:",
		report_body: "",
		action_label: "Visit the bookstore",
		action_url: "https://jabuzwane.co.za/books",
		service_name: `Book delivery update: ${order.bookTitle || "Book"}`,
		booking_date: `Order reference: ${order.orderId || order.id}`,
		booking_time: `Delivery status: ${deliveryStatus === "dispatched" ? "Dispatched" : deliveryStatus}`,
		duration: order.buyerAddress || "",
	}, EMAILJS_PUBLIC_KEY);
}
